<!-- This loader is based on the Nuxt 3 default horizontal loader -->

<script setup lang="ts">
  import { useLoadingIndicator } from './composable/useLoadingIndicator';

  const props = defineProps({
    throttle: {
      type: Number,
      default: 200,
    },
    duration: {
      type: Number,
      default: 2000,
    },
    height: {
      type: Number,
      default: 3,
    },
    color: {
      type: [String, Boolean],
      default: 'rgb(31, 143, 255)',
    },
    errorColor: {
      type: String,
      default: 'repeating-linear-gradient(to right,#f87171 0%,#ef4444 100%)',
    },
    estimatedProgress: {
      type: Function as unknown as () => (duration: number, elapsed: number) => number,
      required: false,
    },
  });

  const { progress, isLoading, error, start, finish, clear } = useLoadingIndicator({
    duration: props.duration,
    throttle: props.throttle,
    estimatedProgress: props.estimatedProgress,
  });

  defineExpose({
    progress,
    isLoading,
    error,
    start,
    finish,
    clear,
  });
</script>

<template>
  <div
    class="loading-indicator"
    :style="{
      height: `${props.height}px`,
      opacity: isLoading ? 1 : 0,
      background: error ? String(props.errorColor) : props.color ? String(props.color) : undefined,
      backgroundSize: `${(100 / progress) * 100}% auto`,
      transform: `scaleX(${progress}%)`,
    }"
  >
    <slot />
  </div>
</template>

<style lang="scss" scoped>
  .loading-indicator {
    // position: fixed;
    pointer-events: none;
    width: auto;
    transform-origin: left;
    // z-index: 999;
    transition:
      transform 0.1s,
      height 0.4s,
      opacity 0.4s;
  }
</style>
